import Axios from "../common/axios"

enum Type {
    WAITING = "FETCH_MODALITY_WAITING"
    , COMPLETED = "FETCH_MODALITY_COMPLETED"
    , ERROR = "FETCH_MODALITY_ERROR"
}

interface Action {
    type: Type
    payload: any
}

export const fetch = () => async (dispatch: (action: any) => any, getState: () => any) => {
    const state = getState().modality

    if (state.loading || state.fetched) {
        return
    }

    const uri = "/api/modality"
    const cache = sessionStorage.getItem(uri)

    if (cache) {
        return dispatch({ type: Type.COMPLETED, payload: { data: JSON.parse(cache) } })
    }

    dispatch({ type: Type.WAITING, payload: {} })

    try {
        const { data, request } = await Axios.get(uri)

        if (request.responseURL.endsWith("/login")) {
            throw new Error("redirected to /login")
        }

        sessionStorage.setItem(uri, JSON.stringify(data))
        dispatch({ type: Type.COMPLETED, payload: { data } })
    } catch (error) {
        dispatch({ type: Type.ERROR, payload: { error } })
    }
}

export interface ModalityState {
    loading: boolean
    , fetched: boolean
    , data: any[]
    , included: any[]
}

const reducer = (prevState: ModalityState, action: Action): ModalityState => {
    const state = { ...prevState }

    switch (action.type) {
        case Type.WAITING:
            state.loading = true
            break
        case Type.COMPLETED:
            state.loading = false
            state.fetched = true

            const { data, included } = action.payload.data

            state.data = [...data]

            if (included) {
                state.included = [...included]
            }
            break
    }

    return state
}

export default reducer